import React, { useState } from "react";
import TableWrapper from "../../../../component/TableWrapper";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

const ReportList = ({ handlePageChange, searchInput }) => {
  const COMPLETED = "Completed";
  const NEW_ENQUIRY = "New";
  const IN_PROGRESS = "In Progress";
  const dispatch = useDispatch();

  const [page, setPage] = useState(1);
  const [reportList, setReportList] = useState({});
  const [isLoading, setisLoading] = useState(false);
  const [sortConfig, setSortConfig] = useState(null);

  const userHeader = [
    { label: "Report Name", sortable: "report_name" },
    { label: "Type", sortable: "type" },
    { label: "Generation", sortable: "generation" },
    { label: "Status", sortable: "status" },
    { label: "Actions" },
  ];

//   const getProductList = async (loading) => {
//     setisLoading(loading);

//     let url = `${Exported.Endpoints.productEnquiryList}`;
//     let paramsObj = {
//       page: page,
//       limit: 10,
//     };
//     if (searchInput && searchInput !== "") {
//       paramsObj["search"] = searchInput;
//     }
//     if (sortConfig) {
//       paramsObj["sort"] = sortConfig?.key;
//       paramsObj["sortOrder"] = sortConfig?.direction;
//     }

//     await request({
//       url: url,
//       params: { ...paramsObj },
//     })
//       .then((res) => {
//         console.log(res);
//         if (res?.data?.status) {
//           const obj = {
//             result: res?.data?.data?.list,
//             pageMeta: res?.data?.data?.pageMeta,
//           };
//           setProductTableList(obj);
//         }
//       })
//       .catch((err) => {
//         console.log(err, "err");
//         Toast({
//           type: "error",
//           message: "Unable to process the request!..",
//         });
//       });
//     setisLoading(false);
//   };

//   useEffect(() => {
//     getProductList(true);
//   }, [searchInput, sortConfig, page]);

  const handleData = (keyValue, defaultValue, className = "") => {
    return (
      <td className={`${className}`}>{keyValue ? keyValue : defaultValue}</td>
    );
  };

//   const redirectTo = (id) => {
//     navigate(`?id=${id}`);
//   };

//   const handleStatus = async (id) => {
//     dispatch(saveLoadingState(true));
//     await request({
//       url: `${Exported.Endpoints.resolveProduct}?enquiry_id=${id}`,
//       method: Exported.APIMethods.PUT,
//       data: {
//         enquiry_id: id,
//       },
//     })
//       .then(async (res) => {
//         if (res?.data?.status) {
//           await getProductList(true);
//           Toast({
//             type: "success",
//             message: "Status updated successfully",
//           });
//         }
//       })
//       .catch((err) => {
//         console.log(err, "err");
//         Toast({
//           type: "error",
//           message: "Unable to process the request!..",
//         });
//       });
//     dispatch(saveLoadingState(false));
//   };


  return (
    <>
      <div className={`eventWrapper`}>
        <div className={`mt-2 mb-5`}>
          <TableWrapper
            headerDetails={userHeader}
            pageMeta={reportList?.pageMeta}
            handlePageChange={setPage}
            listLength={reportList?.result || []}
            isLoading={isLoading}
            sortConfig={sortConfig}
            setSortConfig={setSortConfig}
          >
            {reportList?.result?.map((item, index) => {
              const {
                report_name = "",
                type = "",
                generation = "",
                status = "",
              } = item;
            //   const dateConvert = new Date(enquiry_date);
            //   const monthName = dateConvert.toLocaleString("en-US", {
            //     month: "long",
            //   });
            //   let date = `${dateConvert.getDate()} ${monthName} ${dateConvert.getFullYear()}`;

              return (
                <tr key={report_name}>
                  {handleData(report_name, "-", "text-center")}
                  {handleData('testData', "-", "text-center")}
                  {handleData('testData', "-", "text-center")}
                  {handleData('testData', "-", "text-center")}
                  {handleData('testData', "-", "text-center")}
                  {/* <td className=" px-3 mx-auto text-center">
                    <div
                      className=""
                      style={{
                        color:
                          status === 3
                            ? "#01CB46"
                            : status === 1
                            ? "#FC0000"
                            : status === 2
                            ? "#D99E27"
                            : "#000000",
                      }}
                    >
                      {status === 3
                        ? "Completed"
                        : status === 1
                        ? "New"
                        : status === 2
                        ? "In Progress"
                        : ""}
                    </div>
                  </td> */}
                  {/* <td className=" px-3 mx-auto text-center action-button">
                    <div className="flex items-center justify-center">
                      <img
                        src={Icons.eye}
                        alt="View"
                        className="cursor-pointer w-[20px] h-[20px]"
                        onClick={() => redirectTo(enquiry_id)}
                        style={{
                          pointerEvents: status === 3 ? "none" : "auto",
                        }}
                      />
                      <img
                        src={Icons.checked}
                        alt="Done"
                        className="cursor-pointer w-[22px] h-[22px] mx-2"
                        style={{
                          opacity: status == "2" ? "1" : "0.5",
                          pointerEvents: status == "2" ? "none" : "auto",
                        }}
                        onClick={() =>
                          status == "2" ? handleStatus(enquiry_id) : null
                        }
                      />
                    </div>
                  </td> */}
                </tr>
              );
            })}
          </TableWrapper>
        </div>
      </div>
    </>
  );
};

export default ReportList;
